import type { SwarovskiPageDataFrontend } from "@swo/storefront";
import type { AppStoreState } from "../../store/app-store/app-store-ctx-provider";

export function getNewsletterConfiguration(
  stateConfig: AppStoreState["config"],
  { dataOrError }: SwarovskiPageDataFrontend,
) {
  const isNewsletterShown = stateConfig.newsletter.isNewsletterShown;

  const newsletterData =
    dataOrError._tag === "Right" || dataOrError._tag === "Both" ? dataOrError.right.newsletter : null;

  return {
    isNewsletterShown,
    newsletterData,
  };
}

export type NewsletterConfiguration = ReturnType<typeof getNewsletterConfiguration>["newsletterData"];
